import { FC } from "react";
import InnerPage from "../../../../shared/components/InnerPage";
import Icon, { IconName } from "../../../../shared/components/Icon";
import { PATHS } from "../../../../paths";

const VALUES: { icon: IconName; title: string; text: string }[] = [
  {
    icon: "heart",
    title: "Dürüst",
    text: "Bir Securitas çalışanı dürüsttür. İş ortağının evi, işi ya da değerli eşyaları ona emanet edilebilir. Dürüstlük ilkesi görüşlerini belirtmeyi, uygunsuz durumları bildirmeyi ve bilgi saklamamayı da içerir.",
  },
  {
    icon: "attn",
    title: "Dikkatli",
    text: "Bir Securitas çalışanı her zaman çevresinde olana bitene dikkat eder ve başkalarının göremediği ayrıntıları fark eder. İş ortaklarının iş yerlerinde bulunabilecek riskleri ya da olayları öngörebilecek dikkat ve farkındalığa sahiptir. Çünkü profesyonellik; görmeyi, duymayı ve değerlendirmeyi gerektirir.",
  },
  {
    icon: "people",
    title: "Yardımsever",
    text: "Bir Securitas çalışanı, ihtiyaç duyulduğunda, işiyle doğrudan ilgili olmasa da yardımcı olur. Yaşamı daha huzurlu hale getirmek için müdahale gerektiren bir durum olduğunda muhakkak yardım eder.",
  },
];

const OurValuesPage: FC = () => (
  <InnerPage
    eyebrow="Kurumsal"
    title="Değerlerimiz"
    crumbs={[{ label: "Hakkımızda", to: PATHS.about }, { label: "Değerlerimiz" }]}
    seoDescription="Securitas'ın logosundaki üç kırmızı nokta ile simgelenen dürüstlük, dikkat ve yardımseverlik değerleri, 90 yıldır her kararımıza rehberlik ediyor."
  >
    <div className="it-prose it-prose--wide" style={{ gridColumn: "1 / -1", maxWidth: 900 }}>
      <h2>Değerlerimiz</h2>
      <p>
        Değerlerimiz bize tüm paydaşlarımız ile ilişkilerimizde rehberlik eder.
        Kurum kültürümüz, toplumu herkes için daha güvenli hale getiren dürüst,
        dikkatli ve yardımsever çalışanlar yetiştirmek üzerine kuruludur.
      </p>
      <div className="it-dots3" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
      <p>
        Logomuzdaki üç kırmızı nokta ile simgelenen ''Dürüstlük, Dikkat ve
        Yardımseverlik'' değerlerimiz, 90 yıldır hem yaklaşımımıza hem de aldığımız
        her karara rehberlik ediyor. Bugün, insanların ve mülklerin güvenliğini
        korumak için gururla görev başındayız. Çünkü gerçekten önemli olanı
        korumaya ve dünyayı daha güvenli bir yer haline getirmeye kararlıyız.
      </p>
      <div className="it-values">
        {VALUES.map((value) => (
          <div className="it-val" key={value.title}>
            <div className="it-val-ic">
              <Icon name={value.icon} />
            </div>
            <div>
              <h4>{value.title}</h4>
              <p>{value.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </InnerPage>
);

export default OurValuesPage;
